module.exports = __webpack_public_path__ + "img/louis-pasteur.1cf62c38.png";